










































import Vue from 'vue';
import Component from 'vue-class-component';
import { Global, Reports } from '@/store';

@Component({})
class Sensors extends Vue {
    @Global.State('lang') lang;
    @Global.Mutation('setDeviceClicked') setDeviceClicked;
    @Global.Mutation('setPageTitle') setPageTitle;
    @Reports.Getter('commissionedFloodSensor') commissionedFloodSensor;

    mounted(){
        this.setPageTitle('Flood Sensor');
    }

    sensorClicked(device){
        this.$router.push('/');
        this.setDeviceClicked(device.id);
    }
}

export default Sensors;
